export enum AddressUse {
    Home = 'Home',
    Work = 'Work',
    Temp = 'Temp',
    Old = 'Old',
    Billing = 'Billing'
}

export enum AddressType {
    Postal = 'Postal',
    Physical = 'Physical',
    Both = 'Both'
}

export enum AdmissionType {
    Admission = 'Admission',
    Case = 'Case'
}

export enum AlertNotificationMethod {
    None = 'None',
    Email = 'Email'
}

export enum AlertPriority {
    Low = 'Low',
    Normal = 'Normal',
    High = 'High'
}


export enum AppointmentReminderStatus
{
    CancelRequested = 'CancelRequested',
    Confirmed = 'Confirmed',
    ReminderSent = 'ReminderSent',
    CheckedIn = 'CheckedIn'
}

export enum BirthdayTaskType {
    None = 'None',
    Task = 'Task',
    MessageTemplate = 'MessageTemplate'
}

export enum ContactLanguage {
    English = 'English',
    Spanish = 'Spanish'
}

export enum ContactMethod {
    Email = 'Email',
    SMS = 'SMS'
}

export enum ContactMethodLocation {
    Home = 'Home',
    Work = 'Work',
    Mobile = 'Mobile',
    SecondMobile = 'SecondMobile'
}

export enum ContactPointSystem {
    Phone = 'Phone',
    Fax = 'Fax',
    Email = 'Email',
    Pager = 'Pager',
    URL = 'URL',
    SMS = 'SMS',
    Other = 'Other'
}

export enum ContactPointUse {
    Home = 'Home',
    Work = 'Work',
    Temp = 'Temp',
    Old = 'Old',
    Mobile = 'Mobile'
}

export enum CoverageOrder {
    Primary = 1,
    Secondary = 2,
    Tertiary = 3
}

export enum CoverageStatus {
    Active = 'Active',
    Cancelled = 'Cancelled',
    Draft = 'Draft',
    EnteredInError = 'EnteredInError'
}

export enum EncounterParticipantType {
    SecondaryPerformer = 'SecondaryPerformer',
    PrimaryPerformer = 'PrimaryPerformer',
    Participation = 'Participation'
}

export enum ExtendedMessageType {
    PlainText = 'PlainText',
    Html = 'Html'
}

export enum ExternalFacilityType {
    XfitWoundCare = 'XfitWoundCare',
    XfitTherapy = 'XfitTherapy',
    NhMessaging = 'NhMessaging',
    FOTO = 'FOTO',
    TherapyC = 'TherapyC',
    NhPortal = 'NhPortal'
}

export enum FacilityInviteTrigger
{
    InitialEvaluationVisit = 'InitialEvaluationVisit',
    PatientAdmission = 'PatientAdmission'
}

export enum FacilityType {
    Practice = 'Practice',
    Clinic = 'Clinic'
}

export enum InviteStatus {
    Sent = 'Sent',
    Pending = 'Pending',
    Declined = 'Declined',
    Incomplete = 'Incomplete',
    Complete = 'Complete'
}

export enum LookupTable {
    AdmissionDischargeStatus = 'AdmissionDischargeStatus',
    AppointmentReasonCancelled = 'AppointmentReasonCancelled',
    AppointmentReasonVoided = 'AppointmentReasonVoided',
    AppointmentType = 'AppointmentType',
    CaseDischargeStatus = 'CaseDischargeStatus',
    CaseTherapyDiscipline = 'CaseTherapyDiscipline',
    PatientAdministrativeGender = 'PatientAdministrativeGender',
    PatientGenderIdentity = 'PatientGenderIdentity',
    PatientPreferredLanguage = 'PatientPreferredLanguage',
    PatientPrimaryEthnicity = 'PatientPrimaryEthnicity',
    PatientPrimaryRace = 'PatientPrimaryRace',
    PatientSecondaryEthnicity = 'PatientSecondaryEthnicity',
    PatientSecondaryRace = 'PatientSecondaryRace',
    PatientSexualOrientation = 'PatientSexualOrientation',
    PatientTribalAffiliation = 'PatientTribalAffiliation',
    PhysicianSpecialty = 'PhysicianSpecialty'
}

export enum MessageStatus {
    SendScheduled = 'SendScheduled',
    SendQueued = 'SendQueued',
    SendComplete = 'SendComplete',
    SendCanceled = 'SendCanceled',
    SendFailed = 'SendFailed',
    Logged = 'Logged',
    LoggedCall = 'LoggedCall',
    LoggedCallLeftMessage = 'LoggedCallLeftMessage',
    LoggedCallFailed = 'LoggedCallFailed',
    ReceiveQueued = 'ReceiveQueued',
    ReceiveComplete = 'ReceiveComplete',
    ReceiveFailed = 'ReceiveFailed'
}

export enum MessagingFeature {
    AppointmentReminders = 'AppointmentReminders',
    DigitalIntake = 'DigitalIntake',
    PatientMessaging = 'PatientMessaging',
    ReputationRequest = 'ReputationRequest',
    PatientPortal = 'PatientPortal'
}

export enum MessageType {
    Message = 'Message',
    GroupMessage = 'GroupMessage',
    LogNote = 'LogNote'
}

export enum NameUse {
    Usual = 'Usual',
    Official = 'Official',
    Temp = 'Temp',
    Nickname = 'Nickname',
    Anonymous = 'Anonymous',
    Old = 'Old',
    Maiden = 'Maiden'
}

export enum NpsScoreGroup {
    Promoter = 'Promoter',
    Passive = 'Passive',
    Detractor = 'Detractor'
}

export enum PatientEventType {
    PatientCreated = 'PatientCreated',
    PatientUpdated = 'PatientUpdated',
    PatientDeleted = 'PatientDeleted',
    MessageReceived = 'MessageReceived',
    MessageSent = 'MessageSent',
    MessageCanceled = 'MessageCanceled',
    SubscriptionStarted = 'SubscriptionStarted',
    SubscriptionDeleted = 'SubscriptionDeleted',
    SubscriptionCompleted = 'SubscriptionCompleted',
    SurveySubscriptionCompleted = 'SurveySubscriptionCompleted',
    PatientAdmitted = 'PatientAdmitted',
    PatientDischarged = 'PatientDischarged',
    PatientScheduledVisit = 'PatientScheduledVisit',
    PatientRescheduledVisit = 'PatientRescheduledVisit',
    PatientMadeVisit = 'PatientMadeVisit',
    PatientMissedVisit = 'PatientMissedVisit',
    PatientCanceledVisit = 'PatientCanceledVisit',
    PatientDeletedVisit = 'PatientDeletedVisit',
    PatientRequestedVisit = 'PatientRequestedVisit',
    PatientBirthday = 'PatientBirthday'
}

export enum PatientStatus {
    Active = 'Active',
    Discharged = 'Discharged'
}

export enum PatientContactRelationship {
    AuthorizedRepresentative = 'AuthorizedRepresentative',
    EmergencyContact = 'EmergencyContact',
    Employer = 'Employer',
    FederalAgency = 'FederalAgency',
    Guarantor = 'Guarantor',
    Guardian = 'Guardian',
    GuardianAdLitem = 'GuardianAdLitem',
    InsuranceCompany = 'InsuranceCompany',
    NextOfKin = 'NextOfKin',
    Spouse = 'Spouse',
    StateAgency = 'StateAgency',
    Unknown = 'Unknown'
}

export enum PatientContactRole {
    Patient = 'Patient',
    Guardian = 'Guardian'
}

export enum PatientInviteMethod {
    ContactMethod = 'ContactMethod',
    SelfRegister = 'SelfRegister'
}

export enum PatientSubscriptionTriggerType {
    SurveyPlan = 'SurveyPlan'
}

export enum PatientVisitStatus {
    Scheduled = 'Scheduled',
    Rescheduled = 'Rescheduled',
    Made = 'Made',
    Missed = 'Missed',
    Canceled = 'Canceled',
    Requested = 'Requested'
}

export enum PractitionerRole {
    Clinician = 'Clinician',
    Physician = 'Physician'
}

export enum PreferredContactMethod {
    Email = 'Email',
    Mobile = 'Mobile',
    Phone = 'Phone',
    Text = 'Text'
}

export enum Role {
    FacilityAdmin = 'FacilityAdmin',
    SystemAdmin = 'SystemAdmin',
    ReadOnly = 'ReadOnly',
    FacilityFilteredAccess = 'FacilityFilteredAccess',
    ReportAccess = 'ReportAccess'
}

export enum ServiceType {
    OccupationalTherapy = 'OccupationalTherapy',
    Physiotherapy = 'Physiotherapy',
    SpeechPathologyTherapy = 'SpeechPathologyTherapy',
    WoundManagement = 'WoundManagement'
}

export enum SignatureDocumentFieldType {
    Signature = 'signature',
    Name = 'name',
    Relationship = 'relationship',
    RelatedPersonName = 'relatedPersonName',
    Date = 'date',
    DateTime = 'dateTime',
    Comments = 'comments'
}

export enum SubscriberRelationship {
    Child = 'Child',
    Parent = 'Parent',
    Spouse = 'Spouse',
    Common = 'Common',
    Other = 'Other',
    Self = 'Self',
    Injured = 'Injured'
}

export enum SystemContentType
{
    RegisterEmail = 'RegisterEmail',
    RegisterEmailReminder = 'RegisterEmailReminder',
    RegisterIntro = 'RegisterIntro',
    RegisterConfirm = 'RegisterConfirm',
    RegisterReminder = 'RegisterReminder',
    RegisterReinvite = 'RegisterReinvite',
    RegisterRejected = 'RegisterRejected',
    RegisterConfirmed = 'RegisterConfirmed',
    Help = 'Help',
    RegisterCancel = 'RegisterCancel',
    RegisterResumed = 'RegisterResumed',
    PatientIntakeEmail = 'PatientIntakeEmail',
    PatientIntakeEmailReminder = 'PatientIntakeEmailReminder',
    PatientIntakeEmailReinvite = 'PatientIntakeEmailReinvite',
    PatientIntake = 'PatientIntake',
    PatientIntakeReminder = 'PatientIntakeReminder',
    PatientIntakeReinvite = 'PatientIntakeReinvite',
    PatientIntakeEmailConfirmed = 'PatientIntakeEmailConfirmed',
    PatientIntakeConfirmed = 'PatientIntakeConfirmed',
    PatientIntakeValidationEmail = 'PatientIntakeValidationEmail',
    PatientIntakeValidation = 'PatientIntakeValidation',
    PatientReputationRequest = 'PatientReputationRequest',
    PatientVisitReminderIntro = 'PatientVisitReminderIntro',
    PatientVisitScheduledReminder = 'PatientVisitScheduledReminder',
    PatientVisitRescheduledReminder = 'PatientVisitRescheduledReminder',
    PatientVisitReminder = 'PatientVisitReminder',
    PatientVisitRequestScheduledReminder = 'PatientVisitRequestScheduledReminder',
    PatientVisitRequestRescheduledReminder = 'PatientVisitRequestRescheduledReminder',
    PatientVisitRequestRejectedReminder = 'PatientVisitRequestRejectedReminder',
    PatientVisitRequestDeclinedReminder = 'PatientVisitRequestDeclinedReminder',
    PatientVisitRequestPrompt = 'PatientVisitRequestPrompt',
    PatientVisitIntakePrompt = 'PatientVisitIntakePrompt',
    PatientVisitIntakeComplete = 'PatientVisitIntakeComplete'
}

export enum SystemPlanType {
    PatientIntakeMedicalHistory = 'PatientIntakeMedicalHistory',
    PatientIntakeSignatureDocuments = 'PatientIntakeSignatureDocuments',
    PatientIntakeContacts = 'PatientIntakeContacts',
    PatientIntakeDemographics = 'PatientIntakeDemographics',
    PatientIntakeCaseInformation = 'PatientIntakeCaseInformation',
}

export enum USStates {
    'AL' = 'AL',
    'AK' = 'AK',
    'AZ' = 'AZ',
    'AR' = 'AR',
    'CA' = 'CA',
    'CO' = 'CO',
    'CT' = 'CT',
    'DE' = 'DE',
    'DC' = 'DC',
    'FL' = 'FL',
    'GA' = 'GA',
    'GU' = 'GU',
    'HI' = 'HI',
    'ID' = 'ID',
    'IL' = 'IL',
    'IN' = 'IN',
    'IA' = 'IA',
    'KS' = 'KS',
    'KY' = 'KY',
    'LA' = 'LA',
    'ME' = 'ME',
    'MD' = 'MD',
    'MA' = 'MA',
    'MI' = 'MI',
    'MN' = 'MN',
    'MS' = 'MS',
    'MO' = 'MO',
    'MT' = 'MT',
    'NE' = 'NE',
    'NV' = 'NV',
    'NH' = 'NH',
    'NJ' = 'NJ',
    'NM' = 'NM',
    'NY' = 'NY',
    'NC' = 'NC',
    'ND' = 'ND',
    'OH' = 'OH',
    'OK' = 'OK',
    'OR' = 'OR',
    'PA' = 'PA',
    'PR' = 'PR',
    'RI' = 'RI',
    'SC' = 'SC',
    'SD' = 'SD',
    'TN' = 'TN',
    'TX' = 'TX',
    'UT' = 'UT',
    'VT' = 'VT',
    'VI' = 'VI',
    'VA' = 'VA',
    'WA' = 'WA',
    'WV' = 'WV',
    'WI' = 'WI',
    'WY' = 'WY'
}

export enum WorkflowContentType {
    Newsletter = 'Newsletter',
    Prompt = 'Prompt',
    Template = 'Template'
}

export enum WorkflowContentBooleanCommentsTrigger {
    Never = 'Never',
    TrueResponse = 'TrueResponse',
    FalseResponse = 'FalseResponse'
}

export enum WorkflowContentPromptType {
    Boolean = 'Boolean',
    Date = 'Date',
    Freeform = 'Freeform',
    NetPromoterScore = 'NetPromoterScore',
    Scalar = 'Scalar',
    SignatureDocument = 'SignatureDocument',
    SingleOption = 'SingleOption',
    SingleOptionOther = 'SingleOptionOther',
    Text = 'Text'
}

export enum WorkflowContentPromptTriggerType {
    FreeformResponse = 'FreeformResponse',
    WorkflowContentResponse = 'WorkflowContentResponse'
}

export enum WorkflowContentSegmentAlignment {
    FullWidth = 'FullWidth',
    LeftAlign = 'LeftAlign',
    RightAlign = 'RightAlign'
}

export enum WorkflowContentSegmentType {
    Text = 'Text',
    Heading = 'Heading',
    RichText = 'RichText',
    Image = 'Image'
}

export enum WorkflowContentSegmentEditorMode {
    Message = 'Message',
    Newsletter = 'Newsletter',
    SignatureDocument = 'SignatureDocument',
    VisitReminder = 'VisitReminder',
    DigitalIntake = 'DigitalIntake'
}

export enum WorkflowPlanTriggerType {
    Sequence = 'Sequence',
    StartPlan = 'StartPlan',
    EndPlan ='EndPlan',
    VisitSequence = 'VisitSequence',
    Days = 'Days',
    Weeks = 'Weeks'
}

export enum WorkflowPlanType {
    DirectEngagement = 'DirectEngagement',
    EmailCampaign = 'EmailCampaign',
    Survey = 'Survey'
}

export enum WorkflowPlanSchedulingType {
    Visit = 'Visit',
    Date = 'Date'
}

export enum StaffTaskTriggerType {
    VisitAssignedStaff = 'VisitAssignedStaff',
    CaseAssignedStaff = 'CaseAssignedStaff',
    AssignedStaff = 'AssignedStaff',
}

// front-end enums

export enum VerificationFormStep {
    FormLoading,
    FormError,
    FacilityCodeVerification,
    PatientVerification,
    CodeVerification,
    FormEntry,
    ResendInvite,
    ResendInviteConfirmed
}

export enum VerificationType {
    Invite = 'invite',
    Intake = 'intake',
    VisitIntake = 'visit-intake',
    FacilityVisitIntake = 'facility-visit-intake',
    Form = 'form',
    Portal = 'portal',
    Survey = 'survey'
}